import axiosIns from '@/plugins/axios'

export default {
  // 再送候補（failed + 完了通知が来ていない sent）の一覧
  getPrintTickets() {
    return axiosIns.get('/waiter/print_tickets')
  },

  // レシート系伝票（会計/精算/領収書/概算/債務確認/QR）の印刷依頼（SDP）。
  // サーバーが素材組立とePOS-Print XML生成を行い、プリンタのポーリングで印字される。
  // params のキーはサーバー仕様に合わせて snake_case で渡すこと
  createPrintTicket(params) {
    return axiosIns.post('/waiter/print_tickets', params)
  },

  // 印刷依頼後の状態確認（完了フィードバック用ポーリング）
  getPrintTicket(id) {
    return axiosIns.get(`/waiter/print_tickets/${id}`)
  },

  // 対象チケットを pending に戻し、次回ポーリングで再印刷させる
  resendPrintTicket(id) {
    return axiosIns.post(`/waiter/print_tickets/${id}/resend`)
  },
}
